<template>
  <app-box-booking class="booking-summary w-full" v-if="flightIsSet">
    <h3 class="summary-title ">{{$t("shared.booking_summary")}}</h3>

    <div class="flex items-center">
      <div class="mb-2">
        <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.544 8.342A4.46 4.46 0 0 1 12 3.886a4.46 4.46 0 0 1 4.456 4.456A4.46 4.46 0 0 1 12 12.797a4.46 4.46 0 0 1-4.456-4.455M12 13.392c4.518 0 8.222 3.558 8.454 8.02h.595a8.995 8.995 0 0 0-2.643-5.961 8.973 8.973 0 0 0-3.442-2.16l-.834-.287.727-.5a5.056 5.056 0 0 0 2.193-4.162A5.055 5.055 0 0 0 12 3.292a5.055 5.055 0 0 0-5.05 5.05c0 1.66.82 3.215 2.194 4.161l.726.5-.834.288a8.972 8.972 0 0 0-3.442 2.16 8.994 8.994 0 0 0-2.643 5.96h.595c.232-4.46 3.936-8.02 8.454-8.02" fill="#000" stroke="#000" stroke-width=".3" fill-rule="evenodd"/>
        </svg>
      </div>

      <div class="ml-5">
        {{ passengersCount }} {{$t(passengersCount === 1 ? 'shared.passenger' : 'shared.passengers') }}
      </div>
    </div>

    <!-- Vuelos de ida y vuelta -->
    <div class="summary-body">
      <div class="one-way-trip">
        <h3 class="summary-title">{{ $t("wizard_shared.outbound_trip") }}</h3>

        <div class="flex justify-center items-center">
          <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <path d="M2.746 9.717a.397.397 0 0 0-.198.522l.906 1.924a.402.402 0 0 0 .531.195l6.843-3.162-.62 6.41a.396.396 0 0 0 .133.335c.3.246.674.386 1.063.399.107 0 .214-.014.318-.04.555-.144.986-.633 1.28-1.47l2.692-7.888 5.334-2.46c1.57-.725 2.378-2.195 1.835-3.342A2.037 2.037 0 0 0 21.29.053a3.767 3.767 0 0 0-2.197.335l-6.155 2.855L6.32.683C5.487.373 4.827.38 4.364.71c-.389.315-.61.789-.6 1.286a.397.397 0 0 0 .173.314l4.456 3.03L5.84 6.537 1.562 5.461a.404.404 0 0 0-.447.191L.05 7.552a.4.4 0 0 0 .21.562l3.167 1.293-.68.31zm1.843-7.92a.68.68 0 0 1 .242-.43c.229-.163.648-.139 1.207.068l5.893 2.274L9.242 4.95 4.589 1.798zM.966 7.548l.7-1.23 4.118 1.011a.407.407 0 0 0 .266-.023L19.434 1.12A2.97 2.97 0 0 1 21.153.85c.411.037.778.273.982.629.338.717-.327 1.764-1.45 2.282l-4.637 2.15.282-.824a.404.404 0 0 0-.26-.512.41.41 0 0 0-.517.257l-3.312 9.751c-.198.554-.443.885-.717.956a.687.687 0 0 1-.49-.091l.804-8.363a.401.401 0 0 0-.364-.435.403.403 0 0 0-.44.36l-.125 1.278L4 11.474l-.567-1.195 1.135-.526a.398.398 0 0 0 0-.728L.966 7.547z" id="7wp08knqka"/>
              </defs>
              <use fill="#1D1D1D" fill-rule="nonzero" xlink:href="#7wp08knqka" transform="translate(1.069 5.154)"/>
          </svg>

          <div class="flex gap-5 ml-5">
            <p>{{ name('origin') }}</p>
            <span>-</span>
            <p>{{ name('destination') }}</p>
          </div>
        </div>

        <div class="flex justify-center items-center mt-2.5">
          <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.723 3.692a.3.3 0 0 1 .3.301v.903h6.62v-.903a.3.3 0 0 1 .3-.3h2.106a.3.3 0 0 1 .3.3v.903h2.107a.3.3 0 0 1 .3.3v16.247a.3.3 0 0 1-.3.3H4.21a.3.3 0 0 1-.301-.3V5.197a.3.3 0 0 1 .3-.301h2.107v-.903a.3.3 0 0 1 .3-.3zm11.432 5.115H4.511v12.335h15.644V8.807zm-2.106 1.805v8.725H6.617v-8.725h11.432zm-8.725 6.017H7.218v2.106h2.106v-2.106zm2.708 0H9.926v2.106h2.106v-2.106zm2.708 0h-2.106v2.106h2.106v-2.106zm2.707 0h-2.106v2.106h2.106v-2.106zm-2.707-2.708h-2.106v2.106h2.106v-2.106zm-2.708 0H9.926v2.106h2.106v-2.106zm-2.708 0H7.218v2.106h2.106v-2.106zm8.123 0h-2.106v2.106h2.106v-2.106zm-2.707-2.707h-2.106v2.106h2.106v-2.106zm-2.708 0H9.926v2.106h2.106v-2.106zm-2.708 0H7.218v2.106h2.106v-2.106zm8.123 0h-2.106v2.106h2.106v-2.106zM6.316 5.498H4.51v2.707h15.644V5.498H18.35V6.4a.3.3 0 0 1-.3.3h-2.107a.3.3 0 0 1-.3-.3v-.902h-6.62V6.4a.3.3 0 0 1-.3.3H6.617a.3.3 0 0 1-.301-.3v-.902zm11.432-1.204h-1.504V6.1h1.504V4.294zm-9.326 0H6.918V6.1h1.504V4.294z" fill="#1D1D1D" fill-rule="nonzero"/>
          </svg>

          <div class="flex gap-5 ml-5">
            <p class="text-center">{{ flight.journeyFlightDepartureTime | dayDateAndTime(flight.journeyFlightArrivalTime) }}</p>
          </div>
        </div>
      </div>

      <div class="return-trip mt-5">
        <h3 class="summary-title mt-2">{{ $t("wizard_shared.return_trip") }}</h3>

        <div class="flex justify-center items-center">
          <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <path d="M2.746 9.717a.397.397 0 0 0-.198.522l.906 1.924a.402.402 0 0 0 .531.195l6.843-3.162-.62 6.41a.396.396 0 0 0 .133.335c.3.246.674.386 1.063.399.107 0 .214-.014.318-.04.555-.144.986-.633 1.28-1.47l2.692-7.888 5.334-2.46c1.57-.725 2.378-2.195 1.835-3.342A2.037 2.037 0 0 0 21.29.053a3.767 3.767 0 0 0-2.197.335l-6.155 2.855L6.32.683C5.487.373 4.827.38 4.364.71c-.389.315-.61.789-.6 1.286a.397.397 0 0 0 .173.314l4.456 3.03L5.84 6.537 1.562 5.461a.404.404 0 0 0-.447.191L.05 7.552a.4.4 0 0 0 .21.562l3.167 1.293-.68.31zm1.843-7.92a.68.68 0 0 1 .242-.43c.229-.163.648-.139 1.207.068l5.893 2.274L9.242 4.95 4.589 1.798zM.966 7.548l.7-1.23 4.118 1.011a.407.407 0 0 0 .266-.023L19.434 1.12A2.97 2.97 0 0 1 21.153.85c.411.037.778.273.982.629.338.717-.327 1.764-1.45 2.282l-4.637 2.15.282-.824a.404.404 0 0 0-.26-.512.41.41 0 0 0-.517.257l-3.312 9.751c-.198.554-.443.885-.717.956a.687.687 0 0 1-.49-.091l.804-8.363a.401.401 0 0 0-.364-.435.403.403 0 0 0-.44.36l-.125 1.278L4 11.474l-.567-1.195 1.135-.526a.398.398 0 0 0 0-.728L.966 7.547z" id="7wp08knqka"/>
              </defs>
              <use fill="#1D1D1D" fill-rule="nonzero" xlink:href="#7wp08knqka" transform="translate(1.069 5.154)"/>
          </svg>

          <div class="flex gap-5 ml-5">
            <p>{{ name('destination') }}</p>
            <span>-</span>
            <p>{{ name('origin') }}</p>
          </div>
        </div>

        <div class="flex justify-center items-center mt-2.5">
          <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.723 3.692a.3.3 0 0 1 .3.301v.903h6.62v-.903a.3.3 0 0 1 .3-.3h2.106a.3.3 0 0 1 .3.3v.903h2.107a.3.3 0 0 1 .3.3v16.247a.3.3 0 0 1-.3.3H4.21a.3.3 0 0 1-.301-.3V5.197a.3.3 0 0 1 .3-.301h2.107v-.903a.3.3 0 0 1 .3-.3zm11.432 5.115H4.511v12.335h15.644V8.807zm-2.106 1.805v8.725H6.617v-8.725h11.432zm-8.725 6.017H7.218v2.106h2.106v-2.106zm2.708 0H9.926v2.106h2.106v-2.106zm2.708 0h-2.106v2.106h2.106v-2.106zm2.707 0h-2.106v2.106h2.106v-2.106zm-2.707-2.708h-2.106v2.106h2.106v-2.106zm-2.708 0H9.926v2.106h2.106v-2.106zm-2.708 0H7.218v2.106h2.106v-2.106zm8.123 0h-2.106v2.106h2.106v-2.106zm-2.707-2.707h-2.106v2.106h2.106v-2.106zm-2.708 0H9.926v2.106h2.106v-2.106zm-2.708 0H7.218v2.106h2.106v-2.106zm8.123 0h-2.106v2.106h2.106v-2.106zM6.316 5.498H4.51v2.707h15.644V5.498H18.35V6.4a.3.3 0 0 1-.3.3h-2.107a.3.3 0 0 1-.3-.3v-.902h-6.62V6.4a.3.3 0 0 1-.3.3H6.617a.3.3 0 0 1-.301-.3v-.902zm11.432-1.204h-1.504V6.1h1.504V4.294zm-9.326 0H6.918V6.1h1.504V4.294z" fill="#1D1D1D" fill-rule="nonzero"/>
          </svg>

          <div class="flex gap-5 ml-5">
            <p class="text-center">{{ flight.returnFlightDepartureTime | dayDateAndTime(flight.returnFlightArrivalTime) }}</p>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="flight-prices pb-3" v-if="!isPackFlight">
      <p class="font-bold">Precio viaje x {{ passengersCount }}:</p>
      <p>{{ flightPrice | currency }}</p>
    </div>

    <hr />

    <!-- Hoteles -->
    <template v-if="showHotelDetails">
      <div class="summary-body space-y-2">
        <div class="flex justify-between items-center">
          <h3 class="font-bold">{{ hotel.name }}</h3>
          <p>{{ rooms }}</p>
        </div>
        <div class="flex justify-between">
          <p>{{ $t('wizard_more_days.accommodation_price') }}<span v-if="hotelRateComments.length">*</span>:</p>
          <p>{{ hotelPrice | currency }}</p>
        </div>
      </div>
      <hr />
    </template>

    <!-- Hoteles -->
    <template v-if="isPackFlight">
      <div class="summary-body space-y-2">
        <div class="flex justify-between items-center">
          <h3 class="font-bold">{{ $t('hotel.accomodation') }} {{ selectedCategory.name }} x {{ passengersCount }} : </h3>
          <p>{{ selectedCategory.name === 'luxury' ? '+' + flexExtraTotal + '€' : $t('more_days_landing.included') }}</p>
        </div>
      </div>
      <hr />
    </template>

    <!-- Extras -->
    <template v-if="extras.length">
      <div class="summary-body space-y-2">
        <div class="flex justify-between space-x-4" v-for="extra in extras" :key="extra.id">
          <span>{{ extra.title }} <span v-if="extra.has_counter">x{{ extra.quantity }}</span>:</span>
          <div>
            <span v-if="getExtraPrice(extra.id) === 0">{{$t('shared.free')}}</span>
            <span v-else>{{ getExtraPriceTimesQuantity(extra.id) | currency }}</span>
          </div>
        </div>
      </div>
      <hr />
    </template>

    <!-- Flex Extras-->
    <template v-if="flexExtraSelected">
      <div class="summary-body space-y-2">
        <div class="flex justify-between items-center">
          <p class="font-bold">{{ flexExtraSelected.title }} x {{ passengersCount }}:</p>
          <div>
            <p v-if="flexExtraSelected.price > 0">{{flexExtraSelected.price | currency }}</p>
            <p v-else>{{ $t('more_days_landing.included') }}</p>
          </div>
        </div>
      </div>
      <hr />
    </template>
    <template v-if="!flexExtraSelected">
      <div class="summary-body space-y-2">
        <div class="flex justify-between items-center">
          <p>{{$t('basic_insurance')}}</p>
          <div >
            <p>{{ $t('more_days_landing.included') }}</p>
          </div>
        </div>
      </div>
      <hr />
    </template>

    <!-- Maletas -->
    <div v-if="bagsSummaryInfo.length" class="summary-body space-y-2">
      <div v-for="{ id, name, quantity, totalPrice} in bagsSummaryInfo" :key="id" class="flex justify-between space-x-4">
        <p>{{ name }} x{{ quantity }}</p>
        <p v-if="totalPrice === 0">{{ $t('shared.free') }}</p>
        <p v-else>{{ totalPrice | currency }}</p>
      </div>
    </div>

    <!-- Precios -->
    <div class="summary-prices space-y-3">
      <div v-if="discount" class="summary-body important pt-4 flex justify-between">
        <p>{{ $t('shared.discount_code') }}</p>
        <p class="price">-{{ discount | currency }}</p>
      </div>
      <div class="final-price-container flex flex-col justify-center">
        <div class="flex justify-between items-start">
          <span class="font-bold text-lg">{{ $t('shared.total_price') }}:</span>
          <div class="flex flex-col items-end justify-end">
            <div v-if="extraNoPromoPercentage" class="flex w-full items-center justify-end mb-1">
              <span class="line-through text-sm mr-2">{{ totalPriceNoPromo | currency_no_decimals }}</span>
              <span class="rounded-full bg-discount text-black text-sm px-2 ml-1 py-1">-{{ extraNoPromoPercentage }}%</span>
            </div>
            <p class="font-bold text-lg" v-if="priceWithDiscount > 0 && isPackFlight">{{ priceWithDiscount | currency_no_decimals }}</p>
            <p class="font-bold text-lg" v-else-if="priceWithDiscount > 0">{{ priceWithDiscount | currency }}</p>
            <span class="font-bold text-lg" v-else>{{ $t('shared.free') }}</span>
          </div>
        </div>
        <div v-if="priceWithDiscount > 0 && isPackFlight">
          <div class="flex justify-between items-center my-2">
            <span class="text-sm">{{ $t("wizard_shared.today-you-pay") }}:</span>
            <span>{{ sixtyPercent | currency }}</span>
          </div>
          <div class="flex justify-between items-center mb-4">
            <span class="text-sm">{{ $t("wizard_shared.last-payment") }}:</span>
            <span>{{ fortyPercent | currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <slot></slot>

    <div class="rate-comments mt-8 space-y-2" v-if="showHotelDetails && hotelRateComments.length">
      <p v-for="rateComment in hotelRateComments" :key="rateComment" class="text-xs">
        *{{ rateComment }}
      </p>
    </div>
  </app-box-booking>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import {
  NIGHTS_GET_EXTRA_PRICE_TIMES_QUANTITY,
  NIGHTS_GET_EXTRA_UNIT_PRICE,
  NIGHTS_GET_TOTAL_PRICE,
  GET_NIGHTS_DISCOUNT,
  GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT,
  NIGHTS_GET_PASSENGERS_COUNT,
  NIGHTS_GET_SELECTED_HOTEL_PRICE,
  NIGHTS_GET_BAGS_SUMMARY_INFO,
  NIGHTS_GET_HOTEL_RATE_COMMENTS,
  NIGHTS_GET_TOTAL_PRICE_PACK_HOTELS,
NIGHTS_GET_IS_PACK_FLIGHT,
NIGHTS_GET_LUXURY_EXTRA
} from "../../../store/nights/getter-types";
import { GET_FLEX_EXTRA_SELECTED } from "../../../store/booking/getter-types";

export default {
   props: {
    selectedCategory: {
      type: Object,
      required: false,
    },
    totalPrice: {
      type:Number
    },
    extraNoPromoPercentage: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      getExtraPrice: NIGHTS_GET_EXTRA_UNIT_PRICE,
      getExtraPriceTimesQuantity: NIGHTS_GET_EXTRA_PRICE_TIMES_QUANTITY,
      getTotalPrice: NIGHTS_GET_TOTAL_PRICE,
      hotelPrice: NIGHTS_GET_SELECTED_HOTEL_PRICE,
      discount: GET_NIGHTS_DISCOUNT,
      passengersCount: NIGHTS_GET_PASSENGERS_COUNT,
      priceWithDiscount: GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT,
      bagsSummaryInfo: NIGHTS_GET_BAGS_SUMMARY_INFO,
      hotelRateComments: NIGHTS_GET_HOTEL_RATE_COMMENTS,
      flexExtraSelected: GET_FLEX_EXTRA_SELECTED,
      hotelsPackPrice: NIGHTS_GET_TOTAL_PRICE_PACK_HOTELS,
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
      flexExtraTotal: 'flexExtraTotal',
      flightPrice: 'tripPrice'
    }),
    totalPriceNoPromo() {
        return Number(this.priceWithDiscount) / (1 - this.extraNoPromoPercentage / 100);
    },
    passengers() {
      return this.$store.state.nights.passengers;
    },
    extras() {
      return this.$store.state.nights.extras;
    },
    hotel() {
      return this.$store.state.nights.hotel;
    },
    rooms() {
      const rooms = this.$store.state.nights.rooms;
      return `${rooms} ${rooms === 1 ? "habitación" : "habitaciones"}`;
    },
    flight() {
      return this.$store.state.nights.flight;
    },
    hotelsPrice() {
      return this.$store.state.nights.flight.price + this.totalPrice;

    },
    flightIsSet() {
      return !_.isEmpty(this.flight);
    },
    showHotelDetails() {
      const aHotelIsSelected = !_.isEmpty(this.$store.state.nights.hotel);
      return (
        aHotelIsSelected &&
        ["extras", "datos-personales"].includes(this.$route.params.step)
      );
    },
    sixtyPercent() {
      return this.calculatePercentage(60).toFixed(2);
    },
    fortyPercent() {
      return this.calculatePercentage(40).toFixed(2);
    },
  },
  methods: {
    datetime(direction, type) {
      return this.flight[`${direction}Flight${type}Time`];
    },
    name(type) {
      const { name, code } = this.$store.state.nights[type];
      return `${name} (${code})`;
    },
    calculatePercentage(percentage) {
      const total = this.priceWithDiscount;
      const result = (percentage / 100) * total;
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';

.dotted-line{
  border-top: 1px dotted #979797;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: center;
  margin: 0 0.5rem;
}
.travel-cities{
  p{
    width: max-content;
  }
}
.flight-prices{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 0.8rem;
}
.final-price-container {
  > span {
    font-weight: 900;
    line-height: 1.45;
    &:first-child {
      font-size: 20px;
    }
    &:last-child {
      font-size: 25px;
      color: $turquoiseBlue;
    }
  }
}
</style>
